import React from 'react'
import '../styles/team.css'
import LawyerGrid from '../components/lawyer-grid'

function Team() {
    return (
        <div>
            {/* ZOOM CONTAINER TEAM */}
            <div className='zoom-container-team pt-2 d-flex justify-content-center align-items-center flex-column'>
                <div className='zoom-bg-team'></div>
                <div className='text-center mt-3 zoom-container-team-text'>
                    <span className='zoom-container-span-team'>NUESTRO</span>
                    <span className='zoom-container-span-team fw-bold'>EQUIPO</span>
                </div>
            </div>

            {/* VIDEO CONTAINER TEAM */} 
            <div className='container-video-text pt-5 pb-3'>

                <div className='container-xxl video-container d-flex justify-content-evenly gap-3 align-items-center px-5'>

                    <video controls autoPlay controlsList="nodownload" src={`${process.env.PUBLIC_URL}/media/1.mp4`}>
                    </video>

                    <div className='text-container-video text-center'>

                        <h1 className='team-tittle'>En DEFIENDEME</h1>
                        <h1 className='team-tittle-2'>Protegete <span className='fw-bold'>con los mejores</span></h1>
                        <p className='team-p'>Contamos un equipo de abogados especialistas en materias de derecho civil, laboral, penal, familiar, comercial, administrativo y corporativo, que se encuentran dispuestos a representarte y defender tus derechos de manera profesional y transversal. Confía en los mejores por que protegerte no es una opción, es una <span className='span-2'> NECESIDAD.</span></p>
                    
                    </div>
                </div>


            </div>

            {/* LAWYER GRID */}
            <LawyerGrid />
           
        </div >



    )
}

export default Team         

